<template>
  <div class="logs">
    <h1>Logs</h1>
    <div>
      <select v-model="customerId" @change="getLogs">
        <option value="ffffffff-ffff-ffff-ffff-ffffffffffff" selected
          >&lt;All Customers&gt;</option
        >
        <option
          v-for="customer in customers"
          v-bind:key="customer.customerId"
          v-bind:value="customer.customerId"
          >{{ customer.customerName }}</option
        >
      </select>
      <datepicker
        :value="startDate"
        @selected="setStartDate"
        :disabled-dates="disabledDates"
      ></datepicker>
      -
      <datepicker
        :value="endDate"
        @selected="setEndDate"
        :disabled-dates="disabledDates"
      ></datepicker>
    </div>

    <div class="table-wrapper loader-container">
      <vue-good-table
        v-if="logs"
        :columns="[
          {
            label: 'Customer',
            field: 'site'
          },
          {
            label: 'Component',
            field: 'application'
          },
          {
            label: 'Level',
            field: 'level'
          },
          {
            label: 'Date',
            field: 'date',
            formatFn: formatDateTime
          },
          {
            label: 'Message',
            field: 'message',
            tdClass: 'logs-message'
          }
        ]"
        :rows="logs"
      ></vue-good-table>
      <button
        :class="{ active: i == page }"
        v-for="i in pageCount"
        :key="i"
        @click="setPage(i)"
      >
        {{ i }}
      </button>
      <Loader :loading="loadingLogs" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Loader, VueGoodTable, Datepicker },
  data() {
    return {
      logs: [],
      customers: [],
      customerId: "ffffffff-ffff-ffff-ffff-ffffffffffff",
      startDate: new Date(),
      endDate: new Date(),
      pageCount: Number,
      page: 1,
      disabledDates: {
        from: new Date()
      }
    };
  },
  created() {
    this.getCustomers();
    this.getLogs();
  },
  methods: {
    getLogs() {
      var self = this;
      self.loadingLogs = true;
      service
        .getLogs(
          self.customerId,
          self.formatDate(self.startDate),
          self.formatDate(self.endDate),
          self.page
        )
        .then(response => {
          self.logs = response.data.results;
          self.pageCount = response.data.pageCount;
          self.loadingLogs = false;
        })
        .catch(() => {
          self.loadingLogs = false;
        });
    },
    setPage(page) {
      this.page = page;
      this.getLogs();
    },
    setStartDate(date) {
      this.startDate = date;
      if (this.startDate > this.endDate) {
        this.endDate = this.startDate;
      }
      this.getLogs();
    },
    setEndDate(date) {
      this.endDate = date;
      if (this.endDate < this.startDate) {
        this.startDate = this.endDate;
      }
      this.getLogs();
    },
    getCustomers() {
      var self = this;
      self.loadingCustomers = true;
      service
        .getCustomers()
        .then(response => {
          self.customers = response.data;
          self.loadingCustomers = false;
        })
        .catch(() => {
          self.loadingCustomers = false;
        });
    }
  }
};
</script>
